import {DateTime} from "luxon";
import {singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";
import {Repository} from "../../persistence/repository";
import {User} from "../entities/user.entity";

@singleton()
@persistence({
    entity: User
})
export class UserRepository extends Repository<User> {

    public create(username: string = `user-#${DateTime.utc().toUnixInteger()}`): Promise<User | null> {
        return Promise.resolve(new User(username));
    }
}